import React from "react";
import type { TabOrderItem } from "../../../../services/settings";
import DragElement from "./DragElement";

interface Props {
  elements?: TabOrderItem[] | null;
}

const DragList = ({ elements }: Props) => {
  const renderElement = () => {
    return (
      elements &&
      elements.length > 0 &&
      elements.map((element: TabOrderItem) => (
        <DragElement element={element} key={element.tabId} />
      ))
    );
  };

  return <>{renderElement()}</>;
};

export default React.memo(DragList);
